//DEVELOP ENVIRONMENT
const baseURL = '';

//SERVER ENVIRONMENT
//const baseURL = '';

const ApiEndpoints = {
    UserLogin: `${baseURL}user/login`,
    UserLogout: `${baseURL}account/login`,
    CreateUser: `${baseURL}account/login`,
    UpdateUser: `${baseURL}user`,
    CreateProductBuild: `${baseURL}ProductBuild/create`,
}

export default ApiEndpoints;